import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubble6"><Path d="M2.5 8.5C2.5 5.73858 4.73858 3.5 7.5 3.5H16.5C19.2614 3.5 21.5 5.73858 21.5 8.5V15.5C21.5 18.2614 19.2614 20.5 16.5 20.5H2.5V8.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubble6;
